function route(name, params = null, query = {}) {
  let url

  if (name === 'index') {
    url = '/'
  } else {
    const hasParams =
      params !== null &&
      params !== undefined &&
      !(
        typeof params === 'object' &&
        !Array.isArray(params) &&
        Object.keys(params).length === 0
      )

    url = hasParams ? window.reverseUrl(name, params) : window.reverseUrl(name)
  }

  const qs = new URLSearchParams(query).toString()
  return qs ? `${url}?${qs}` : url
}

export default route